var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"control-feature-container"},[_c('a',{on:{"click":function($event){return _vm.$root.eventHub.$emit('previous-feature')}}},[_c('p',[_vm._v("Previous")])]),_c('a',{on:{"click":function($event){return _vm.$root.eventHub.$emit('next-feature')}}},[_c('p',[_vm._v("Next")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }